import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WarningState {
  neutrophilWarningPatientIds: string[];
  neutrophilWarning: boolean;
}

const initialState: WarningState = {
  neutrophilWarningPatientIds: [],
  neutrophilWarning: false,
};

export const warningSlice = createSlice({
  name: "warning",
  initialState,
  reducers: {
    setPatientneutrophilWarning: (state, action: PayloadAction<{ ids: string[] }>) => {
      state.neutrophilWarningPatientIds = state.neutrophilWarningPatientIds.concat(action.payload.ids);
      state.neutrophilWarning = true;
    },
    removePatientneutrophilWarning: (state, action: PayloadAction<{ ids: string[] }>) => {
      state.neutrophilWarningPatientIds = state.neutrophilWarningPatientIds.filter((element) =>
        action.payload.ids.includes(element)
      );
      state.neutrophilWarning = state.neutrophilWarningPatientIds.length > 0;
    },
  },
});
